import React from 'react'
import styled from '@emotion/styled'

import ConditionPage from './ConditionPage'
import ImageIconSvgs from './imageCapture/ImageIconSvgs'
import PhotoGuidelinesModal from './imageCapture/PhotoGuidelinesModal'
import ConfirmationModal from '../generic/modals/ConfirmationModal'
import useImageCapture from '../../hooks/components/useImageCapture'
import { ExteriorPageNumber } from '../../constants'
import Error from '../generic/Error'
import ImageCaptureWebComponentWrapper from './ImageCaptureWebComponentWrapper'

export default props => {
  const {
    setShowModal,
    updateGlobalState,
    experienceState,
    prospectId,
    globalState: { isImageCaptureWebComponentEnabled, allWebComponentPhotosUploaded, photoUploadedUrls, environment }
  } = props
  const { photoSection, subheader, title, selectedImage, confirmDeleteImage, confirmKeepImage, onNextPageSelected, anyPhotosUploadedAndTrue, isNextClicked, ...hookProps } = useImageCapture(props)
  const disclaimer = 'If vehicle images are inconsistent with other information you provide, it may impact the accuracy of the Offer.'
  const isRequirePhotos = experienceState.cobrandingInfo && experienceState.cobrandingInfo.isRequirePhoto
  // default Condition Page values
  updateGlobalState({ np: ExteriorPageNumber, cp: ExteriorPageNumber })

  const shouldUseImageCaptureWebComponent = (isImageCaptureWebComponentEnabled || experienceState.isCombinedOffer) && environment.funnelWebComponentUrl
  const theme = experienceState.theme
  return (
    <ConditionPage
      {...{ title, subheader, photoSection, anyPhotosUploadedAndTrue, shouldUseImageCaptureWebComponent, allWebComponentPhotosUploaded, photoUploadedUrls, isRequirePhotos, ...props }}
      onNextClicked={() => onNextPageSelected(photoUploadedUrls)}
      pageName="imageCapture"
      noDamage={!shouldUseImageCaptureWebComponent && !isRequirePhotos && 'No photos to add? Select Next'}>
      {shouldUseImageCaptureWebComponent ? (
        <ImageCaptureWebComponentWrapper
          prospectId={prospectId}
          isRequiredPhotos={isRequirePhotos}
          isNextClicked={isNextClicked}
          allWebComponentPhotosUploaded={allWebComponentPhotosUploaded}
          photoUploadedUrls={photoUploadedUrls}
          environment={environment}
          updateGlobalState={updateGlobalState}
          theme={theme}
        />
      ) : (
        <>
          <ImageIconSvgs {...{ title: `Add Photos${isRequirePhotos ? '' : ' (Optional)'}`, photoSection, disclaimer, ...hookProps }} />
          {isRequirePhotos && !anyPhotosUploadedAndTrue && isNextClicked && <Error isError={true} id="color-error" text="Please upload all photos." />}
          <PhotoGuidelinesModal setShowModal={setShowModal} />
          <ConfirmationModal testId="vc-image-capture" modalName="DeleteImage" title="Delete Image" confirmText="Delete" cancelText="Keep" onConfirmSelected={confirmDeleteImage} onCancelSelected={confirmKeepImage}>
            <ContentGroup>
              <b>Are you sure you want to delete this photo?</b>
              <div>{selectedImage?.categoryName}</div>
            </ContentGroup>
          </ConfirmationModal>
        </>
      )}
    </ConditionPage>
  )
}

const ContentGroup = styled.div`
  display: flex;
  flex-basis: 60px;
  flex-direction: column;
  div {
    margin-top: 4px;
  }
`
